import { Injectable } from '@angular/core';
import { Rol, Polisi } from '../../modelau/defnyddiwr/rol';
import { StorfaDefnyddiwrService } from '../system/storfa-defnyddiwr.service';

@Injectable({
  providedIn: 'root'
})
export class AwdurdodiService {

  constructor(private storfaDefnyddiwrService: StorfaDefnyddiwrService) { }

  gwirioRol(rolAwdurdodi: Rol): boolean {

    const defnyddiwr = this.storfaDefnyddiwrService.nolProffil();

    let ynCaelMynediad = false;

    if (!defnyddiwr || !defnyddiwr.rol) {
      return ynCaelMynediad;
    }

    switch (rolAwdurdodi) {
      case Rol.UwchWeinyddwr: {
        ynCaelMynediad = this.gwirioPolisi(defnyddiwr.rol, Polisi.PolisiUwchWeinyddwr);
        break;
      }
      case Rol.Gweinyddwr: {
        ynCaelMynediad = this.gwirioPolisi(defnyddiwr.rol, Polisi.PolisiGweinyddwr);
        break;
      }
      case Rol.Mecanig: {
        ynCaelMynediad = this.gwirioPolisi(defnyddiwr.rol, Polisi.PolisiMecanig);
        break;
      }
      case Rol.Yswiriant: {
        ynCaelMynediad = this.gwirioPolisi(defnyddiwr.rol, Polisi.PolisiYswiriant);
        break;
      }
      case Rol.Defnyddiwr: {
        ynCaelMynediad = this.gwirioPolisi(defnyddiwr.rol, Polisi.PolisiDefnyddiwr);
        break;
      }
      case Rol.Archwiliwr: {
        ynCaelMynediad = this.gwirioPolisi(defnyddiwr.rol, Polisi.PolisiArchwiliwr);
        break;
      }
      default: {
        break;
      }
    }

    return ynCaelMynediad;
  }

  private gwirioPolisi(rol: Rol, polisi: any): boolean {
    if (polisi.find((x: Rol) => x === rol)) {
      return true;
    }

    return false;
  }
}
